import { render, staticRenderFns } from "./audit-card.vue?vue&type=template&id=bfd246f4&scoped=true&"
import script from "./audit-card.vue?vue&type=script&lang=js&"
export * from "./audit-card.vue?vue&type=script&lang=js&"
import style0 from "./audit-card.vue?vue&type=style&index=0&id=bfd246f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd246f4",
  null
  
)

component.options.__file = "audit-card.vue"
export default component.exports